/* @flow */

import { fadeDuration, pressDuration } from '@braindate/ui/lib/token/animation';
import { hoverSelector } from '@braindate/ui/lib/token/selector';

import type { ThemeFunction } from 'src/shared/app/base/types/themeTypes';

export default {
  root: {
    textAlign: 'center',
    textDecoration: 'none',
    color: ({ theme }: ThemeFunction) => theme.textColor,

    transition: [
      ['opacity', fadeDuration],
      ['transform', pressDuration],
    ],

    [hoverSelector]: {
      opacity: 0.5,
    },
    '&:active': {
      transform: 'scale(0.90, 0.90)',
    },
  },

  platform: {
    display: 'inline',
  },
  logo: {
    width: ({ imgWidth }: ThemeFunction) => imgWidth,
    // To override a class defined in backpack
    maxHeight: '72px !important',

    objectFit: 'contain',
    objectPosition: 'left',
  },
};
